import { ApiStatusResponse, CoreApiStatusResponse } from '@common/type/CoreApiResponseTypes';

export function isApiResponseSuccess(status: CoreApiStatusResponse): boolean {
  return status === ApiStatusResponse.SUCCESS;
}
